import BrandsFilter from './brands-filter';

export default BrandsFilter;
